import { has } from 'lodash-es';
import {
  IMAGE_EMPTY_BOX,
  IMAGE_HS_TASKS_LOGO,
  IMAGE_SET_UP_THE_SUCCESS,
  INSIGHTS_LOGO,
  INSIGHTS_ACTIVITY_TRACKING_DISABLED,
  INSIGHTS_TOOLS_TRACKING_DISABLED,
  INSIGHTS_TOOLS_TRACKING_UNUSED,
  INSIGHTS_NO_TIME_TRACKED,
  INSIGHTS_INTEGRATION_UNAUTHORIZED,
  INSIGHTS_GITHUB_INTEGRATION_LOGO,
  INSIGHTS_GITHUB_INTEGRATION_LOGO_WHITE,
  INSIGHTS_MEETINGS_GOOGLE_LOGO,
  INSIGHTS_MEETINGS_MICROSOFT365_LOGO,
  INSIGHTS_DONUT_CHART_PLACEHOLDER,
  INSIGHTS_SHORT_PARAGRAPH_PLACEHOLDER,
  INSIGHTS_MEETINGS_DIALOG_ILLUSTRATION,
  INSIGHTS_MEETINGS_CONNECT,
  INSIGHTS_COLUMN_CHART_PLACEHOLDER,
  INSIGHTS_BANNER_UPGRADE,
  INSIGHTS_BANNER_ENABLE,
  INSIGHTS_BANNER_WORKFORCE,
  INSIGHTS_BANNER_SUSPICIOUS_BEHAVIOR,
  INSIGHTS_BANNER_DIALOG_WTE,
  INSIGHTS_BANNER_DIALOG__APP_URLS,
  INSIGHTS_BANNER_DIALOG_HIGHLIGHTS,
  INSIGHTS_BANNER_DIALOG_FOCUS_TIME,
  INSIGHTS_RANKING_BLURRED_ITEMS_4,
  INSIGHTS_RANKING_BLURRED_ITEMS_5,
  INSIGHTS_RANKING_BLURRED_ITEMS_10,
  INSIGHTS_TIMELINE_BLURRED_APPS_URLS,
  INSIGHTS_OUTPUT_NO_DATA,
  INSIGHTS_UNUSUAL_ACTIVITIES_BLURRED_APPS,
  INSIGHTS_CANCELLATION_BANNER_ILLUSTRATION_RED,
  INSIGHTS_CANCELLATION_BANNER_ILLUSTRATION_BLUE,
  INSIGHTS_CANCELLATION_BANNER_ILLUSTRATION_30_DAYS,
  INSIGHTS_CANCELLATION_BANNER_ILLUSTRATION_10_PERCENT,
  HS_TIMER_WINDOWS,
  HS_TIMER_APPLE,
  HS_TIMER_LINUX,
  HS_TIMER_CHROME,
  HS_TIMER_ANDROID,
  HS_TIMER_WEB_TIMER,
  HUBSTAFF_LOGO,
  INTEGRATIONS_HERO_WISE,
  TRANSFERWISE_LOGO,
  GETTING_STARTED_NO_TEAM_MEMBER_SELECTED,
  GETTING_STARTED_SCREENSHOTS,
  GETTING_STARTED_TIMESHEET_APPROVED,
  GETTING_STARTED_FREE_TRIAL_INSIGHTS,
  GETTING_STARTED_DOWNLOAD_APP_IMG_1,
  GETTING_STARTED_DOWNLOAD_APP_IMG_2,
  GETTING_STARTED_DOWNLOAD_APP_IMG_3,
  ACHIEVEMENT_BADGE_EFFICIENCY_PRO,
  ACHIEVEMENT_BADGE_TIME_HERO,
  ACHIEVEMENT_BADGE_PRODUCTIVITY_CHAMP,
  ACTIVITIES_VIEW_ROUTE_ACTIVE,
  ACTIVITIES_VIEW_ROUTE_INACTIVE,
  ACTIVITIES_VIEW_INFO_ACTIVE,
  ACTIVITIES_VIEW_INFO_INACTIVE,
  ACTIVITIES_INSIGHTS_DONUT_CHART_PLACEHOLDER,
  ACTIVITIES_INSIGHTS_PIE_CHART_PLACEHOLDER,
  SCHEDULED_REPORT_BANNER_ILLUSTRATION,
  TEAMS_PROMOTION_BANNER_ILLUSTRATION,
  CONTRACTOR_COMPLIANCE_BANNER_ILLUSTRATION,
  SETTINGS_SMART_NOTIFICATION_HIGH_ACTIVITY,
  SMART_NOTIFICATIONS_SUSPICIOUS_APPS,
  SMART_NOTIFICATIONS_SUSPICIOUSLY_HIGH_ACTIVITY,
  SETTINGS_SMART_NOTIFICATIONS_OVERWORKING,
  SMART_NOTIFICATIONS_OVERWORKING,
  SETTINGS_SMART_NOTIFICATIONS_UNDERWORKING,
  SMART_NOTIFICATIONS_UNDERWORKING,
  SETTINGS_SMART_NOTIFICATIONS_LOW_ACTIVITY,
  SMART_NOTIFICATIONS_LOW_ACTIVITY,
  SMART_NOTIFICATIONS_LOW_CORE_WORK,
  SMART_NOTIFICATIONS_UNPRODUCTIVE_WORK,
  ICON_WATCH,
  ICON_BELL,
  ORGANIZATION_ARCHIVE_BANNER_ILLUSTRATION_RED,
  SMART_NOTIFICATIONS_SOCIAL_MEDIA_WEBSITES,
  SMART_NOTIFICATIONS_NOT_USING_APPS,
  SMART_NOTIFICATIONS_AI_WEBSITES,
  SMART_NOTIFICATIONS_ENTERTAINMENT_WEBSITES,
  SMART_NOTIFICATIONS_IDLE_TIME,
  SMART_NOTIFICATIONS_MANUAL_TIME,
} from '~/rails_assets';
import { getFileImportTemplateUrl } from './utils/asset_url_helper';

export const CONSTANTS = {
  noDataToSendTooltip: 'There is no data to send',
  ownershipSpentTooltip:
    "Only owners and managers with 'Manage Financials' permission may see spent data on team reports",
  ownershipBillableTooltip: "Only owners and managers with 'Manage Financials' permission may see billable data",
  quickbooksDataTooltip:
    'Organization does not have the required Quickbooks data. Please edit the organization to add it.',
  immutableTooltip: 'This time entry has been paid or logged to an external integration and cannot be modified.',
  projectArchivedTooltip: 'This time entry is in an archived project and cannot be modified.',
  permissionedDeniedTooltip: "You don't have permission to edit this time entry",
  viewerProjectMemberDeniedTooltip: 'Viewers cannot be added to the job site.',
  // #teams-addon (jobsites)
  jobSiteRuleOtherProjectsTooltip:
    'Not all members are added to these projects. Selecting one will automatically add the members above.',
  jobSiteRuleOtherProjectsWithTeamsTooltip:
    'Not all teams and members are added to these projects. Selecting one will automatically add the teams & members above.',
  noMemberSelectedProjectTooltip: 'You must select at least one member to view projects',
  noMemberSelectedProjectWithTeamsTooltip: 'You must select at least one team or a member to view projects',
  jobSitesDisabledTeamsAddonTooltip: 'Teams addon disabled. Please reenable the addon or replace teams with users.',
  noProjectsTooltip: 'No projects',
  reset2faTooltip:
    'Resetting 2FA for a member will require them to generate new authorization codes in order to log back into their accounts',
  cannotReset2faTooltip: 'You cannot reset two-factor authentication for this member',
};

export const DEFAULT_MARKER_CIRCLE_OPTIONS = {
  fillColor: '#7fcaff',
  strokeColor: '#2f8af4',
};

// Fallback default radius (meters) used when neither the org's
// configured default nor the server-provided value is available.
// Must stay in sync with Rails.configuration.job_sites.default_radius.
export const JOB_SITE_DEFAULT_RADIUS = 150;

// JOB_SITE_RECORD values format
// "${client_location_tracking}-${passive_location_tracking}"
export const JOB_SITE_RECORD = {
  always: '1-2',
  trackingTime: '1-0',
  alsoDuringShifts: '1-1',
};
export const JOB_SITE_RECORD_VISITS = [
  {
    id: `enter-${JOB_SITE_RECORD.trackingTime}`,
    value: JOB_SITE_RECORD.trackingTime,
    text: 'When tracking time',
  },
  {
    id: `enter-${JOB_SITE_RECORD.alsoDuringShifts}`,
    value: JOB_SITE_RECORD.alsoDuringShifts,
    text: 'When tracking & during shifts',
  },
  {
    id: `enter-${JOB_SITE_RECORD.always}`,
    value: JOB_SITE_RECORD.always,
    text: 'Always record visits',
  },
];

export const JOB_SITE_ACTIONS = {
  doNothing: 'none',
  trackTime: 'track',
  sendReminder: 'notify',
};
export const JOB_SITE_ENTER_ACTIONS = [
  {
    id: `enter-${JOB_SITE_ACTIONS.trackTime}`,
    value: JOB_SITE_ACTIONS.trackTime,
    text: 'Start timer',
  },
  {
    id: `enter-${JOB_SITE_ACTIONS.sendReminder}`,
    value: JOB_SITE_ACTIONS.sendReminder,
    text: 'Send reminder',
  },
  {
    id: `enter-${JOB_SITE_ACTIONS.doNothing}`,
    value: JOB_SITE_ACTIONS.doNothing,
    text: "Don't start timer",
  },
];
export const JOB_SITE_EXIT_ACTIONS = [
  {
    id: `exit-${JOB_SITE_ACTIONS.trackTime}`,
    value: JOB_SITE_ACTIONS.trackTime,
    text: 'Stop timer',
  },
  {
    id: `exit-${JOB_SITE_ACTIONS.sendReminder}`,
    value: JOB_SITE_ACTIONS.sendReminder,
    text: 'Send reminder',
  },
  {
    id: `exit-${JOB_SITE_ACTIONS.doNothing}`,
    value: JOB_SITE_ACTIONS.doNothing,
    text: "Don't stop timer",
  },
];

export const IMPORT_MEMBER_OPTIONS = [
  {
    id: 1,
    value: 'invites',
    text: 'Send invites',
  },
  {
    id: 2,
    value: 'accounts',
    text: 'Create accounts',
  },
];

export const WORK_ORDERS_URL = '/organizations/:organizationId/work_orders/:woId';
export const ATTENDANCE_SCHEDULES_URL = '/organizations/:organizationId/schedules/:scheduleId';
export const UPDATE_NOTIFICATION_SETTINGS_URL = '/organizations/:id/update_notification_settings';

export const WORK_ORDER_DIALOG_TABS = {
  general: 0,
  jobSite: 1,
  budget: 2,
};

export const JOB_REPEAT_TYPE = {
  Once: 'once',
  Weekly: 'weekly',
  Monthly: 'monthly',
  Yearly: 'yearly',
};

// From to `job_decorator.rb#14
export const JOB_VIRTUAL_STATES = [
  { id: 'scheduled', text: 'Scheduled' },
  { id: 'attended', text: 'Attended' },
  { id: 'late', text: 'Late' },
  { id: 'missed', text: 'Missed' },
  { id: 'mixed_attendance', text: 'Mixed attendance' },
  { id: 'completed', text: 'Completed' },
];

export const ORGANIZATION_LOCATIONS_ACTIVITIES_URL = '/organizations/:organizationId/activities/locations';

export const ORGANIZATION_MAP_URL = '/organizations/:orgId/map';

export const LOCATION_MAP_OPTIONS = {
  mapTypeControl: false,
  disableDefaultUI: true,
  zoomControl: true,
  zoomControlOptions: {
    style: 2,
    position: 6,
  },
};

export const LOCATION_VIEW = {
  LIVE: 0,
  PAST: 1,
};

export const LOCATION_VIEW_OPTIONS = [
  { id: `location-mode-${LOCATION_VIEW.LIVE}`, text: 'Live', value: LOCATION_VIEW.LIVE },
  { id: `location-mode-${LOCATION_VIEW.PAST}`, text: 'Past', value: LOCATION_VIEW.PAST },
];

export const LOCATION_SITES_MODE = {
  VISITED: 0,
  ALL: 1,
};

export const LOCATION_SITES_MODE_OPTIONS = [
  { id: 'visited', text: 'Visited', value: LOCATION_SITES_MODE.VISITED },
  { id: 'all', text: 'All job sites', value: LOCATION_SITES_MODE.ALL },
];

export const LOCATION_DATA_VALUES = {
  all: 0,
  active: 1,
  passive: 2,
};

export const DEBUG_LOCATION_DATA_OPTIONS = [
  {
    id: `location-view-${LOCATION_DATA_VALUES.all}`,
    value: LOCATION_DATA_VALUES.all,
    text: 'All',
  },
  {
    id: `location-view-${LOCATION_DATA_VALUES.active}`,
    value: LOCATION_DATA_VALUES.active,
    text: 'Only active',
  },
  {
    id: `location-view-${LOCATION_DATA_VALUES.passive}`,
    value: LOCATION_DATA_VALUES.passive,
    text: 'Only passive',
  },
];

export const DEBUG_LOCATION_PATH_OPTIONS = [
  { id: 'location-path-1', value: 1, text: 'On' },
  { id: 'location-path-0', value: 0, text: 'Off' },
];

export const AVATARS_MAX_DISPLAYABLE_MEMBERS = 3;

export const ATTENDANCE_SCHEDULE_URL = '/schedules/:attendanceScheduleId';
export const ATTENDANCE_SHIFT_URL = '/organizations/:organizationId/attendance_shifts/:attendanceShiftId';
export const TIME_OFF_REQUEST_URL = '/time_off_requests/:id';

export const TIME_OFF_POLICY_ERRORS_TO_CHECK = [
  'accrual_policy',
  'accrual_type',
  'allow_negative_balances',
  'auto_add_new_users',
  'balance_rolls_over_annually',
  'name',
  'paid',
  'requires_approval',
];

export const SEND_REPORT_FORMAT_PDF = 'pdf';
export const SEND_REPORT_FORMAT_CSV = 'csv';

export const SEND_REPORT_FORMATS = [
  { id: SEND_REPORT_FORMAT_PDF, key: 'pdf', text: 'PDF' },
  { id: SEND_REPORT_FORMAT_CSV, key: 'csv', text: 'CSV' },
];

export const SCHEDULED_REPORT_FORMAT_PDF = 0;
export const SCHEDULED_REPORT_FORMAT_CSV = 1;

export const SCHEDULED_REPORT_FORMATS = [
  { id: SCHEDULED_REPORT_FORMAT_PDF, key: 'pdf', text: 'PDF' },
  { id: SCHEDULED_REPORT_FORMAT_CSV, key: 'csv', text: 'CSV' },
];

export const SCHEDULED_REPORT_DATE_RANGE_TODAY = { id: 0, text: 'Today' };
export const SCHEDULED_REPORT_DATE_RANGE_THIS_WEEK = { id: 3, text: 'This week' };
export const SCHEDULED_REPORT_DATE_RANGE_LAST_WEEK = { id: 4, text: 'Last week' };

export const SCHEDULED_REPORT_DATE_RANGES = [
  SCHEDULED_REPORT_DATE_RANGE_TODAY,
  { id: 1, text: 'Yesterday' },
  { id: 2, text: 'The last 7 days' },
  SCHEDULED_REPORT_DATE_RANGE_THIS_WEEK,
  SCHEDULED_REPORT_DATE_RANGE_LAST_WEEK,
  { id: 5, text: 'The last 2 weeks' },
  { id: 6, text: 'This month' },
  { id: 7, text: 'Last month' },
];
export const SCHEDULED_REPORT_WEEKLY_DATE_RANGES = [
  SCHEDULED_REPORT_DATE_RANGE_THIS_WEEK,
  SCHEDULED_REPORT_DATE_RANGE_LAST_WEEK,
];

export const SCHEDULED_REPORT_INTERVAL_DAILY = 0;
export const SCHEDULED_REPORT_INTERVAL_WEEKLY = 1;
export const SCHEDULED_REPORT_INTERVAL_MONTHLY = 2;
export const SCHEDULED_REPORT_INTERVAL_BIWEEKLY = 3;

export const SCHEDULED_REPORT_INTERVALS = [
  { id: SCHEDULED_REPORT_INTERVAL_DAILY, text: 'Daily' },
  { id: SCHEDULED_REPORT_INTERVAL_WEEKLY, text: 'Weekly' },
  { id: SCHEDULED_REPORT_INTERVAL_BIWEEKLY, text: 'Bi-weekly' },
  { id: SCHEDULED_REPORT_INTERVAL_MONTHLY, text: 'Monthly' },
];

export const SUPPORTED_REPORT_FORMATS = {
  default: ['pdf', 'csv'],
};

export default CONSTANTS;

export const mapConstants = (constantList) => {
  const result = {};

  for (const constant of constantList) {
    if (has(CONSTANTS, constant)) {
      result[constant] = () => CONSTANTS[constant];
    } else {
      throw new Error(`'${constant}' is not a valid constant`);
    }
  }

  return result;
};

export const USER_PROJECT_ROLE_VIEWER = 3;

export const TIME_ENTRY_MODIFIABLE_REASONS = {
  processed_paid: 'This time has been paid.',
  paid: 'This time has been paid.',
  invoiced: 'This time has been invoiced by organization.',
  user_invoiced: 'This time has been invoiced by team member.',
  task_synced: 'This time has been logged to an external integration.',
  time_synced: 'This time has been logged to an external integration.',
  timesheet: 'This time has been timesheet approved.',
  tracking_disabled: 'Time tracking disabled.',
  modify_time_disabled: 'Modify time setting disabled.',
  viewer: 'Member is only a viewer and cannot track time.',
  archived: 'The project is archived and cannot be edited.',
  no_permission: 'You do not have permission to edit this time.',
  work_break: 'Work breaks cannot be edited.',
  manual_time_request: 'Manual time request cannot be edited.',
};

export const MANUAL_TIME_REQUEST_TIME_ENTRY_COLOR = '#6b7280';

export const TIMESHEET_STATUSES = {
  1: 'Open',
  2: 'Submitted',
  3: 'Approved',
  4: 'Denied',
  5: 'Paid',
};

// Active job site time span as minutes
export const ACTIVE_WORKER_TIME_SPAN = 15;
export const ACTIVE_JOB_SITE_TIME_SPAN = 15;

export const MEMBER_ROLES = {
  0: 'user',
  2: 'manager',
  3: 'viewer',
};

export const USER_ROLES_ENUM = {
  User: 0,
  Owner: 1,
  Manager: 2,
  Viewer: 3,
};

export const MANAGER_ROLE = 'manager';
export const USER_ROLE = 'user';
export const VIEWER_ROLE = 'viewer';
export const MULTIPLE_PROJECT_ROLES = 'by_project';

export const ORGANIZATION_OWNER_ROLE = 1;
export const ORGANIZATION_MANAGER_ROLE = 2;
export const PROJECT_VIEWER_ROLE = 'Project viewer';

export const BUDGET_TYPE_COST = 0;
export const BUDGET_TYPE_HOURS = 1;
export const BUDGET_TYPE_OPTIONS = [
  { id: BUDGET_TYPE_COST, text: 'Total cost' },
  { id: BUDGET_TYPE_HOURS, text: 'Total hours' },
];
export const BUDGET_USE_BILL_RATE = 0;
export const BUDGET_USE_PAY_RATE = 1;
export const BUDGET_USE_OPTIONS = [
  { id: BUDGET_USE_BILL_RATE, text: 'Bill rate' },
  { id: BUDGET_USE_PAY_RATE, text: 'Pay rate' },
];
export const BUDGET_NOTIFY_ORG_MANAGEMENT_OPTION = 'org_management';
export const BUDGET_NOTIFY_ALL_MEMBERS_OPTION = 'all_members';
export const BUDGET_WHO_TO_NOTIFY_OPTIONS = [
  { id: BUDGET_NOTIFY_ORG_MANAGEMENT_OPTION, text: 'Org management' },
  { id: BUDGET_NOTIFY_ALL_MEMBERS_OPTION, text: 'All members' },
];
export const BUDGET_RECURRENCE_NEVER = '';
export const BUDGET_RECURRENCE_WEEKLY = 'weekly';
export const BUDGET_RECURRENCE_MONTHLY = 'monthly';
export const BUDGET_RECURRENCE_OPTIONS = [
  { id: BUDGET_RECURRENCE_NEVER, text: 'Never' },
  { id: BUDGET_RECURRENCE_MONTHLY, text: 'Monthly' },
];
export const WO_BUDGET_RECURRENCE_OPTIONS = [
  { id: BUDGET_RECURRENCE_NEVER, text: 'Never' },
  { id: BUDGET_RECURRENCE_WEEKLY, text: 'Weekly' },
  { id: BUDGET_RECURRENCE_MONTHLY, text: 'Monthly' },
];

export const ACTIVE_CLIENT_STATUS = 0;
export const ARCHIVED_CLIENT_STATUS = 1;

export const ACTIVE_PROJECT_STATUS = 0;
export const ARCHIVED_PROJECT_STATUS = 1;
export const DELETED_PROJECT_STATUS = 2;

export const PRESELECTED_USER_ROLES = [
  { id: 0, value: 0, text: 'User' },
  { id: 2, value: 2, text: 'Manager', feature: 'projects' },
  { id: 3, value: 3, text: 'Viewer', feature: 'projects' },
];

export const ALLOWED_APP_ITEMS = [
  { id: 0, value: 0, text: 'All apps' },
  { id: 1, value: 1, text: 'Desktop only' },
];

export const MODIFY_TIME_OPTIONS = [
  { id: 1, value: true, text: 'Add & Edit' },
  { id: 0, value: false, text: 'Off' },
];

export const IDLE_TIMEOUT_ITEMS = [
  { id: 0, text: 'Never' },
  { id: 300, text: '5 mins' },
  { id: 600, text: '10 mins' },
  { id: 1200, text: '20 mins' },
  { id: 'undefined', text: 'Custom' },
];

export const KEEP_IDLE_TIME_ITEMS = [
  { id: 0, value: 0, text: 'Prompt' },
  { id: 1, value: 1, text: 'Always' },
  { id: 2, value: 2, text: 'Never' },
];

export const MEMBERSHIP_ROLE_OPTIONS = [
  {
    id: 'organization_owner',
    value: 'organization_owner',
    text: 'Organization owner',
    description: 'Can do everything',
  },
  {
    id: 'organization_manager',
    value: 'organization_manager',
    text: 'Organization manager',
    description: 'Can do everything, except manage financials (depending on permissions) and send payments',
  },
  {
    id: 'project_manager',
    value: 'project_manager',
    text: 'Project manager',
    description:
      "Can manage, track, view screenshots of members they oversee and report for any project they're added to.",
    feature: 'projects',
  },
  {
    id: 'project_user',
    value: 'project_user',
    text: 'User',
    description: "Can track and view their time for any project they're added to",
    title: 'Most common',
    feature: 'projects',
  },
  {
    id: 'project_viewer',
    value: 'project_viewer',
    text: 'Project viewer',
    description: "Can view reports for any project they're added to (viewers are free)",
    feature: 'projects',
  },
  {
    id: 'by_project',
    value: 'by_project',
    text: 'Multiple project roles',
    description: 'Can be a manager on some projects and a member on others',
    title: 'Advanced',
    feature: 'projects',
  },
  {
    id: 'unassigned',
    value: 'unassigned',
    text: 'No role',
    description: 'The user has no role assigned yet, and is not charged.',
  },
];
export const MEMBERSHIP_ROLE_OPTIONS_NEW = [
  {
    id: 'organization_owner',
    value: 'organization_owner',
    text: 'Organization owner',
    description: 'Can do everything',
  },
  {
    id: 'organization_manager',
    value: 'organization_manager',
    text: 'Organization manager',
    description: 'Can do everything, except manage financials (depending on permissions) and send payments',
  },
  {
    id: 'by_project',
    value: 'by_project',
    text: 'User',
    description: 'Can track time to projects and be assigned multiple project roles',
    title: 'Most common',
    feature: 'projects',
  },
  {
    id: 'project_viewer',
    value: 'project_viewer',
    text: 'Project viewer',
    description: "Can view reports for any project they're added to (viewers are free)",
    feature: 'projects',
  },
  {
    id: 'unassigned',
    value: 'unassigned',
    text: 'No role',
    description: 'The user has no role assigned yet, and is not charged.',
  },
];
export const ORGANIZATION_ROLE_PERMISSIONS = {
  organization_owner: {},
  organization_manager: {
    manage_billing: {
      label: 'Manage Financials',
      descr: `
        <ul class="aligned-list text-left">
          <li>View and edit members bill/pay rates (global and per project)</li>
          <li>View payments and reports</li>
          <li>Create and send client invoices</li>
          <li>Not able to send payments or manage Hubstaff subscription</li>
        </ul>
        `,
    },
    others_screenshots: {
      label: 'View screenshots/activities for other members',
      descr: 'Allows the member to see screenshots from other members in the organization',
    },
  },
  project_manager: {},
  project_user: {},
  project_viewer: {},
  by_project: {
    manage_it: {
      label: 'Manage IT',
      descr: 'Allows the member to configure SSO/SCIM, manage Silent app deployment, and auto-tracking policies',
    },
  },
};

export const USER_ORGANIZATION = {
  User: 0,
  Owner: ORGANIZATION_OWNER_ROLE,
  Manager: ORGANIZATION_MANAGER_ROLE,
  Unassigned: 3,
};

export const USER_PROJECT = {
  User: 0,
  Manager: 2,
  Viewer: 3,
};

export const ORGANIZATION_OWNER = `${USER_ORGANIZATION.Owner}-${USER_PROJECT.Manager}`;
export const ORGANIZATION_MANAGER = `${USER_ORGANIZATION.Manager}-${USER_PROJECT.Manager}`;
export const PROJECT_USER = `${USER_ORGANIZATION.User}-${USER_PROJECT.User}`;
export const PROJECT_MANAGER = `${USER_ORGANIZATION.User}-${USER_PROJECT.Manager}`;
export const PROJECT_VIEWER = `${USER_ORGANIZATION.User}-${USER_PROJECT.Viewer}`;
export const BY_PROJECT = `${USER_ORGANIZATION.User}--1`;
export const SINGLE_ROLE_UNASSIGNED = `${USER_ORGANIZATION.Unassigned}--1`;

export const PROJECT_ID_PREFIX = 'p_';

export const MEMBER_STATUS_FILTER_OPTIONS = [
  { id: '', text: 'All' },
  { id: '0', text: 'Active' },
  { id: '1', text: 'Removed' },
];

export const MEMBER_ROLE_FILTER_OPTIONS = [
  { id: 'owner', text: 'Organization owner' },
  { id: 'manager', text: 'Organization manager' },
  { id: 'project_manager', text: 'Project manager', feature: 'projects' },
  { id: 'lead', text: 'Team lead' },
  { id: 'user', text: 'User' },
  { id: 'project_viewer', text: 'Project viewer', feature: 'projects' },
];

export const MEMBER_PROFILE = {
  TABS: ['info', 'employment', 'teams', 'projects-and-roles', 'pay / bill', 'work hours', 'settings'],
  DEFAULT_TAB: 0,
};

export const MEMBERSHIP_PAY_PERIOD_OPTIONS = [
  { id: '', text: 'None', key: 'none' },
  { id: '0', text: 'Weekly', key: 'weekly' },
  { id: '1', text: 'Twice per month', key: 'twice_per_month' },
  { id: '2', text: 'Bi-weekly', key: 'biweekly' },
  { id: '3', text: 'Monthly', key: 'monthly' },
];

export const WEEKLY_PAY_PERIOD = '0';
export const TWICE_PER_MONTH_PAY_PERIOD = '1';
export const BIWEEKLY_PAY_PERIOD = '2';
export const MONTHLY_PAY_PERIOD = '3';

// Matches UserOrganization::DEFAULT_PAY_PERIOD_CONFIG[:period_week_day] (Monday)
export const DEFAULT_PERIOD_WEEK_DAY = 0;
export const DEFAULT_PERIOD_START_DAY = 1;
export const DEFAULT_PERIOD_SECOND_START_DAY = 16;

// Day-of-week options for pay period day selector (displayed in calendar order: Su-Sa)
export const PAY_PERIOD_DAY_OF_WEEK_OPTIONS = [
  { label: 'Su', value: 6, name: 'Sunday' },
  { label: 'Mo', value: 0, name: 'Monday' },
  { label: 'Tu', value: 1, name: 'Tuesday' },
  { label: 'We', value: 2, name: 'Wednesday' },
  { label: 'Th', value: 3, name: 'Thursday' },
  { label: 'Fr', value: 4, name: 'Friday' },
  { label: 'Sa', value: 5, name: 'Saturday' },
];

// Day-of-month options for monthly/twice-per-month pay period day selector (1-28)
// Last day of month is set to 31
export const PAY_PERIOD_DAY_OF_MONTH_OPTIONS = [
  { id: '1', text: '1st', value: 1 },
  { id: '2', text: '2nd', value: 2 },
  { id: '3', text: '3rd', value: 3 },
  { id: '4', text: '4th', value: 4 },
  { id: '5', text: '5th', value: 5 },
  { id: '6', text: '6th', value: 6 },
  { id: '7', text: '7th', value: 7 },
  { id: '8', text: '8th', value: 8 },
  { id: '9', text: '9th', value: 9 },
  { id: '10', text: '10th', value: 10 },
  { id: '11', text: '11th', value: 11 },
  { id: '12', text: '12th', value: 12 },
  { id: '13', text: '13th', value: 13 },
  { id: '14', text: '14th', value: 14 },
  { id: '15', text: '15th', value: 15 },
  { id: '16', text: '16th', value: 16 },
  { id: '17', text: '17th', value: 17 },
  { id: '18', text: '18th', value: 18 },
  { id: '19', text: '19th', value: 19 },
  { id: '20', text: '20th', value: 20 },
  { id: '21', text: '21st', value: 21 },
  { id: '22', text: '22nd', value: 22 },
  { id: '23', text: '23rd', value: 23 },
  { id: '24', text: '24th', value: 24 },
  { id: '25', text: '25th', value: 25 },
  { id: '26', text: '26th', value: 26 },
  { id: '27', text: '27th', value: 27 },
  { id: '28', text: '28th', value: 28 },
  { id: '31', text: 'Last day of month', value: 31 },
];

export const MEMBERSHIP_RATE_TYPE_OPTIONS = [
  { id: '0', text: 'Hourly', key: 'hourly' },
  { id: '1', text: 'Fixed', key: 'fixed_amount' },
];

export const RATE_TYPE_EXTERNAL = '2';
export const FIXED_RATE_TYPE = '1';
export const RATE_LIMIT = 99999999.99;
export const EXTERNAL_PAY_PERIOD = 'Remote';

export const DAYS_ALLOWED_TO_WORK = [
  { value: 0, text: 'sun' },
  { value: 1, text: 'mon' },
  { value: 2, text: 'tue' },
  { value: 3, text: 'wed' },
  { value: 4, text: 'thu' },
  { value: 5, text: 'fri' },
  { value: 6, text: 'sat' },
];

export const MAX_WEEKLY_LIMIT = 168; // hours
export const MAX_DAILY_LIMIT = 24; // hours

export const APPROX_EARTH_RADIUS = 6371000.0;

export const ACTIVITY_BENCHMARKS = {
  time: {
    label: 'Worked Time',
    items: {
      total_worked: {
        label: 'Total worked',
        type: 'time',
        default: '0:00',
        visible: true,
      },
      prev_day_comparison: {
        label: 'To prev day',
        type: 'time',
        default: '=',
        visible: false,
      },
    },
  },
  activity: {
    label: 'Avg. Activity',
    items: {
      average: {
        label: 'Average',
        type: 'percentage',
        default: '—',
        visible: true,
      },
      prev_day_comparison: {
        label: 'To prev day',
        type: 'percentage',
        default: '—',
        visible: false,
      },
      organization_average: {
        label: 'To org avg',
        type: 'percentage',
        default: '—',
        visible: false,
      },
    },
  },
  tasks: {
    label: 'To-Dos',
    items: {
      completed_count: {
        label: 'Completed',
        type: 'number',
        default: '0',
      },
      prev_day_comparison: {
        label: 'To prev day',
        type: 'number',
        default: '=',
      },
    },
  },
};

export const HS_TIMER_PLATFORMS = {
  desktop: [
    {
      name: 'Windows',
      image: HS_TIMER_WINDOWS,
    },
    {
      name: 'Mac OS X',
      image: HS_TIMER_APPLE,
    },
    {
      name: 'Linux',
      image: HS_TIMER_LINUX,
    },
    {
      name: 'Chromebook',
      image: HS_TIMER_CHROME,
    },
  ],
  browser: [
    {
      name: 'Chrome extension',
      image: HS_TIMER_CHROME,
    },
  ],
  mobile: [
    {
      name: 'iOS',
      image: HS_TIMER_APPLE,
    },
    {
      name: 'Android',
      image: HS_TIMER_ANDROID,
    },
  ],
  web: [
    {
      name: 'Web timer',
      image: HS_TIMER_WEB_TIMER,
    },
  ],
};

export const PROJECT_TYPES = {
  project: 1,
  workOrder: 2,
  workBreak: 3,
};

export const WORK_BREAK_RULES = [
  { id: 0, text: 'No restrictions' },
  { id: 1, text: 'Once per work session' },
  { id: 2, text: 'Allow within every few hours' },
  { id: 3, text: 'Allow after every few hours' },
];

export const ACTIVITY_LEVEL_FILTERS = [
  { id: 'above_95', text: '> 95%' },
  { id: 'above_90', text: '> 90%' },
  { id: 'above_80', text: '> 80%' },
  { id: 'above_70', text: '> 70%' },
  { id: 'above_60', text: '> 60%' },
  { id: 'above_50', text: '> 50%' },
  { id: 'below_50', text: '< 50%' },
  { id: 'below_40', text: '< 40%' },
  { id: 'below_30', text: '< 30%' },
  { id: 'below_20', text: '< 20%' },
  { id: 'below_10', text: '< 10%' },
];

export const ACTIVITY_TIME_TYPE_FILTERS = [
  { id: 0, text: 'Normal' },
  { id: 268435456, text: 'Idle' },
  { id: 536870912, text: 'Resumed' },
  { id: 805306368, text: 'Manual' },
];

export const TIME_WORKED_TRACKED_FILTER_VALUE = 0;
export const TIME_WORKED_NOT_TRACKED_FILTER_VALUE = 1;
export const TIME_WORKED_FILTER_OPTIONS = {
  withTimeTracked: TIME_WORKED_TRACKED_FILTER_VALUE,
  withNoTimeTracked: TIME_WORKED_NOT_TRACKED_FILTER_VALUE,
};

export const INVOICING_FREQUENCY_BIWEEKLY = 1;
export const INVOICING_TYPE_PER_HOUR = 0;
export const INVOICING_TYPE_FIXED = 1;
export const DELAY_MAX_VALUE = 31;
export const REMINDER_MAX_VALUE = 365;

// `color` for the white text badge bg
// `lightColor` for colored text badge bg, use `color` for text
export const INSIGHTS_CONFIDENCE_LEVELS = [
  { key: 'low', name: 'Slightly unusual', color: 'var(--z-green-800)', lightColor: 'var(--z-green-100)' },
  { key: 'medium', name: 'Unusual', color: 'var(--z-orange-800)', lightColor: 'var(--z-orange-100)' },
  { key: 'high', name: 'Highly unusual', color: 'var(--z-red-700)', lightColor: 'var(--z-red-100)' },
];

const INSIGHTS_SMART_NOTIFICATIONS_HELPER = {
  insightsBaseMetricTypes: {
    work_time: 'Work time',
    core_time: 'Core work rate',
    unproductive_time: 'Unproductive work rate',
    non_core_time: 'Non-core work rate',
    activity: 'Avg. Activity rate',
    time_spent_in_app: 'Time spent on App',
    time_spent_in_url: 'Time spent on URL',
    idle_time: 'Idle time',
    idle_time_percent: 'Idle time percentage',
    manual_time: 'Manual time',
    manual_time_percent: 'Manual time percentage',
    geo_ip_changes: 'Geo-IP changes',
    users_per_ip: 'Users sharing an IP',
    geo_ip_list_match: 'Geo-IP list match'
  },
};

export const SETTINGS_SMART_NOTIFICATIONS = {
  defaultFormSetting: {
    condition: 'above',
    target: {},
    condition_value: '00:30',
    consecutive_units: 'days',
    consecutive_value: '3',
    consider_weekends: false,
    frequency: 'weekly',
    metric_type: 'work_time',
    name: '',
    time_unit: 'per_day',
    recipients: {},
    deliver_by: {
      email: false,
      insights: true,
      slack: false,
    },
  },
  options: {
    /**
     * We don't have time_spent_in_url and time_spent_in_app metric types on the BE side, we only have time_spent_in_tool
     * We do it this way, so we can separate UI on the client side.
     * We'll change the metric type before submitting the form.
     */
    events: {
      hourly: [
        { id: 'work_time', text: 'Hourly work time' },
        { id: 'core_time', text: 'Core work' },
        { id: 'non_core_time', text: 'Non-core work' },
        { id: 'unproductive_time', text: 'Unproductive work' },
        { id: 'activity', text: 'Avg. Activity rate' },
        { id: 'suspicious_activity', text: 'Suspicious applications' },
        { id: 'time_spent_in_app', text: 'Time spent on App' },
        { id: 'time_spent_in_url', text: 'Time spent on URL' },
      ],
      daily: [
        { id: 'work_time', text: 'Daily work time' },
        { id: 'core_time', text: 'Core work' },
        { id: 'non_core_time', text: 'Non-core work' },
        { id: 'unproductive_time', text: 'Unproductive work' },
        { id: 'activity', text: 'Avg. Activity rate' },
        { id: 'suspicious_activity', text: 'Suspicious applications' },
        { id: 'unusual_activity', text: 'Unusual activity' },
        { id: 'time_spent_in_app', text: 'Time spent on App' },
        { id: 'time_spent_in_url', text: 'Time spent on URL' },
        { id: 'idle_time', text: 'Daily idle time (hr)' },
        { id: 'idle_time_percent', text: 'Idle time (%)' },
        { id: 'manual_time', text: 'Daily manual time (hr)' },
        { id: 'manual_time_percent', text: 'Manual time (%)' },
        { id: 'geo_ip_changes', text: 'Geo-IP changes', feature: 'geo_ip_audit_log' },
        { id: 'users_per_ip', text: 'Users sharing an IP', feature: 'geo_ip_audit_log' },
        { id: 'geo_ip_list_match', text: 'Geo-IP list match', feature: 'geo_ip_audit_log' },
      ],
      weekly: [
        { id: 'work_time', text: 'Weekly work time' },
        { id: 'core_time', text: 'Core work' },
        { id: 'non_core_time', text: 'Non-core work' },
        { id: 'unproductive_time', text: 'Unproductive work' },
        { id: 'activity', text: 'Avg. Activity rate' },
        { id: 'suspicious_activity', text: 'Suspicious applications' },
        { id: 'unusual_activity', text: 'Unusual activity' },
        { id: 'time_spent_in_app', text: 'Time spent on App' },
        { id: 'time_spent_in_url', text: 'Time spent on URL' },
        { id: 'idle_time', text: 'Weekly idle time (hr)' },
        { id: 'idle_time_percent', text: 'Idle time (%)' },
        { id: 'manual_time', text: 'Weekly manual time (hr)' },
        { id: 'manual_time_percent', text: 'Manual time (%)' },
        { id: 'geo_ip_changes', text: 'Geo-IP changes', feature: 'geo_ip_audit_log' },
        { id: 'users_per_ip', text: 'Users sharing an IP', feature: 'geo_ip_audit_log' },
        { id: 'geo_ip_list_match', text: 'Geo-IP list match', feature: 'geo_ip_audit_log' },
      ],
      monthly: [
        { id: 'work_time', text: 'Monthly work time' },
        { id: 'core_time', text: 'Core work' },
        { id: 'non_core_time', text: 'Non-core work' },
        { id: 'unproductive_time', text: 'Unproductive work' },
        { id: 'activity', text: 'Avg. Activity rate' },
        { id: 'suspicious_activity', text: 'Suspicious applications' },
        { id: 'unusual_activity', text: 'Unusual activity' },
        { id: 'time_spent_in_app', text: 'Time spent on App' },
        { id: 'time_spent_in_url', text: 'Time spent on URL' },
        { id: 'idle_time', text: 'Monthly idle time (hr)' },
        { id: 'idle_time_percent', text: 'Idle time (%)' },
        { id: 'manual_time', text: 'Monthly manual time (hr)' },
        { id: 'manual_time_percent', text: 'Manual time (%)' },
      ],
    },
    condition: [
      { id: 'above', text: 'Above' },
      { id: 'below', text: 'Below' },
    ],
    target: [
      {
        text: 'Teams',
        key: 'teams',
      },
      {
        text: 'Members',
        key: 'members',
      },
      {
        text: 'Job types',
        key: 'occupations',
      },
    ],
    consecutiveUnits: [
      { id: 'days', text: 'Days' },
      { id: 'weeks', text: 'Weeks' },
    ],
    consecutiveUnitsSingular: [
      { id: 'days', text: 'Day' },
      { id: 'weeks', text: 'Week' },
    ],
    frequency: [
      { id: 'hourly', text: 'Every hour' },
      { id: 'daily', text: 'Every day' },
      { id: 'weekly', text: 'Every week' },
      { id: 'monthly', text: 'Every month' },
    ],
    timeBasedMetrics: ['work_time', 'time_spent_in_app', 'time_spent_in_url', 'idle_time', 'manual_time'],
    countMetrics: ['geo_ip_changes', 'users_per_ip', 'geo_ip_list_match'],
    notifications: {
      hourly:
        'This configuration may cause notifications to be fired every hour of the day, even while users are not working.',
      unusual_activity:
        'This notification will inform you of the total duration of unusual activity for each monitored member, based on the chosen frequency.',
      suspicious_activity:
        'This notification will inform you when a known fake activity application is detected, which member triggered it, and the name of the app.',
      geo_ip_changes:
        'This notification will fire when a monitored member exceeds the configured number of geo-IP changes in the chosen frequency window.',
      users_per_ip:
        'This notification will fire when more than the configured number of monitored members share the same IP address in the chosen frequency window.',
      geo_ip_list_match:
        'This notification will fire when a monitored member\'s geo-IP changes match (or do not match) the configured list of IPs, cities, or countries in the chosen frequency window.',
    },
    time_unit: [
      { id: 'per_hour', text: 'min/hr' },
      { id: 'per_day', text: 'hr/day' },
      { id: 'per_week', text: 'hr/week' },
      { id: 'per_month', text: 'hr/month' },
    ],
    roles: [
      { id: 'owner', text: 'Owners' },
      { id: 'manager', text: 'Managers' },
      { id: 'team_lead', text: 'Team leads' },
    ],
  },
  presets: {
    suspicious_apps: {
      name: 'Suspicious applications',
      metric_type: 'suspicious_activity',
      condition: 'above',
      condition_value: '1',
      frequency: 'hourly',
      deliver_by: {
        slack: false,
        email: true,
        insights: true,
      },
      target_all_members: true,
      recipients: { roles: ['owner', 'manager', 'team_lead'], members: [] },
    },
    high_activity: {
      name: 'Suspiciously high activity',
      metric_type: 'activity',
      condition: 'above',
      condition_value: '90',
      consider_weekends: true,
      frequency: 'hourly',
      deliver_by: {
        slack: false,
        email: true,
        insights: true,
      },
      target_all_members: true,
      recipients: { roles: ['owner', 'manager', 'team_lead'], members: [] },
    },
    overworking: {
      name: 'Members overworking',
      metric_type: 'work_time',
      condition: 'above',
      condition_value: '09:30',
      consecutive_value: '5',
      consecutive_units: 'days',
      consider_weekends: true,
      frequency: 'weekly',
      deliver_by: {
        slack: false,
        email: true,
        insights: true,
      },
      target_all_members: true,
      recipients: { roles: ['owner', 'manager', 'team_lead'], members: [] },
    },
    underworking: {
      name: 'Members underworking',
      metric_type: 'work_time',
      condition: 'below',
      condition_value: '05:00',
      consecutive_value: '5',
      consecutive_units: 'days',
      consider_weekends: false,
      frequency: 'weekly',
      deliver_by: {
        slack: false,
        email: true,
        insights: true,
      },
      target_all_members: true,
      recipients: { roles: ['owner', 'manager', 'team_lead'], members: [] },
    },
    low_activity: {
      name: 'Members with low activity level',
      metric_type: 'activity',
      condition: 'below',
      condition_value: '35',
      consecutive_value: '5',
      consecutive_units: 'days',
      consider_weekends: false,
      frequency: 'weekly',
      deliver_by: {
        slack: false,
        email: true,
        insights: true,
      },
      target_all_members: true,
      recipients: { roles: ['owner', 'manager', 'team_lead'], members: [] },
    },
    low_core_work: {
      name: 'Members with low core work',
      metric_type: 'core_time',
      condition: 'below',
      condition_value: '25',
      consider_weekends: false,
      frequency: 'weekly',
      deliver_by: {
        slack: false,
        email: true,
        insights: true,
      },
      target_all_members: true,
      recipients: { roles: ['owner', 'manager', 'team_lead'], members: [] },
    },
    unproductive_work: {
      name: 'Members with unproductive work time',
      metric_type: 'unproductive_time',
      condition: 'above',
      condition_value: '10',
      consider_weekends: false,
      frequency: 'daily',
      deliver_by: {
        slack: false,
        email: true,
        insights: true,
      },
      target_all_members: true,
      recipients: { roles: ['owner', 'manager', 'team_lead'], members: [] },
    },
    members_using_social_media_websites: {
      name: 'Members using social media websites',
      metric_type: 'time_spent_in_url',
      condition: 'above',
      condition_value: '00:30',
      frequency: 'daily',
      deliver_by: {
        slack: false,
        email: true,
        insights: true,
      },
      target_all_members: true,
      recipients: { roles: ['owner', 'manager', 'team_lead'], members: [] },
      tools: {
        names: [
          'facebook.com',
          'instagram.com',
          'tiktok.com',
          'reddit.com',
          'pinterest.com',
          'messenger.com',
          'twitch.tv',
          'tumblr.com',
          'threads.net',
          'snapchat.com',
          'web.snapchat.com',
          'douyin.com',
          'myspace.com',
          'vk.com',
          'x.com',
        ],
      },
    },
    members_using_AI_websites: {
      name: 'Members using AI websites',
      metric_type: 'time_spent_in_url',
      condition: 'above',
      condition_value: '00:30',
      frequency: 'daily',
      deliver_by: {
        slack: false,
        email: true,
        insights: true,
      },
      target_all_members: true,
      recipients: { roles: ['owner', 'manager', 'team_lead'], members: [] },
      tools: {
        names: [
          'chatgpt.com',
          'gemini.google.com',
          'claude.ai',
          'perplexity.ai',
          'copilot.microsoft.com',
          'openai.com',
          'you.com',
          'writesonic.com',
          'jasper.ai',
        ],
      },
    },
    members_usings_entertainment_websites: {
      name: 'Members using entertainment websites',
      metric_type: 'time_spent_in_url',
      condition: 'above',
      condition_value: '00:30',
      frequency: 'daily',
      deliver_by: {
        slack: false,
        email: true,
        insights: true,
      },
      target_all_members: true,
      recipients: { roles: ['owner', 'manager', 'team_lead'], members: [] },
      tools: {
        names: [
          'netflix.com',
          'disneyplus.com',
          'hulu.com',
          'paramountplus.com',
          'max.com',
          'youtube.com',
          'primevideo.com',
          'bilibili.com',
          'fandom.com',
          'kwai-video.com',
        ],
      },
    },
    members_not_using_required_apps: {
      name: 'Members not using required applications',
      metric_type: 'time_spent_in_app',
      condition: 'below',
      condition_value: '00:30',
      frequency: 'weekly',
      deliver_by: {
        slack: false,
        email: true,
        insights: true,
      },
      target_all_members: true,
      recipients: { roles: ['owner', 'manager', 'team_lead'], members: [] },
    },
    suspicious_application_autoclicker: {
      name: 'Alert on AutoClicker',
      metric_type: 'time_spent_in_app',
      frequency: 'daily',
      condition: 'above',
      condition_value: '60',
      time_unit: 'per_day',
      deliver_by: {
        slack: false,
        email: true,
        insights: true,
      },
      target_all_members: true,
      recipients: { roles: ['owner', 'manager', 'team_lead'], members: [] },
      tools: {
        names: ['AutoClicker'],
      },
    },
    idle_time: {
      name: 'Members with high idle time',
      metric_type: 'idle_time_percent',
      condition: 'above',
      condition_value: '15',
      consider_weekends: false,
      frequency: 'weekly',
      deliver_by: {
        slack: false,
        email: true,
        insights: true,
      },
      target_all_members: true,
      recipients: { roles: ['owner', 'manager', 'team_lead'], members: [] },
    },
    manual_time: {
      name: 'Members with high manual time',
      metric_type: 'manual_time_percent',
      condition: 'above',
      condition_value: '15',
      consider_weekends: false,
      frequency: 'weekly',
      deliver_by: {
        slack: false,
        email: true,
        insights: true,
      },
      target_all_members: true,
      recipients: { roles: ['owner', 'manager', 'team_lead'], members: [] },
    },
    // Part of exp 0229 Slack Unusual Activity Setup
    // TODO: remove if AR0229 fails / keep if it wins
    unusual_activity_to_slack: {
      name: 'Unusual Activity to Slack [Automatic Alert]',
      metric_type: 'unusual_activity',
      frequency: 'daily',
      deliver_by: {
        slack: true,
        email: false,
        insights: true,
      },
      target_all_members: true,
      recipients: { roles: ['owner', 'manager', 'team_lead'], members: [] },
      source: 'slack_ua_setup_nudge',
    },
  },
  templates: {
    suspicious_apps: {
      thumbnail_src: SMART_NOTIFICATIONS_SUSPICIOUS_APPS,
      label: 'Suspicious applications',
      description: 'Identify suspicious apps generating fake activity',
      frequency: 'Hourly',
      trigger: 'Email',
    },
    high_activity: {
      src: SETTINGS_SMART_NOTIFICATION_HIGH_ACTIVITY,
      thumbnail_src: SMART_NOTIFICATIONS_SUSPICIOUSLY_HIGH_ACTIVITY,
      label: 'Suspiciously high activity',
      description: 'Average hourly activity levels exceed 90%',
      frequency: 'Hourly',
      trigger: 'Email',
    },
    overworking: {
      src: SETTINGS_SMART_NOTIFICATIONS_OVERWORKING,
      thumbnail_src: SMART_NOTIFICATIONS_OVERWORKING,
      label: 'Members overworking',
      description: 'Average daily work time exceeds 9.5 hours per week',
      frequency: 'Weekly',
      trigger: 'Email',
    },
    underworking: {
      src: SETTINGS_SMART_NOTIFICATIONS_UNDERWORKING,
      thumbnail_src: SMART_NOTIFICATIONS_UNDERWORKING,
      label: 'Members underworking',
      description: 'Average daily work time falls below 5 hours',
      frequency: 'Weekly',
      trigger: 'Email',
    },
    low_activity: {
      src: SETTINGS_SMART_NOTIFICATIONS_LOW_ACTIVITY,
      thumbnail_src: SMART_NOTIFICATIONS_LOW_ACTIVITY,
      label: 'Members with low activity level',
      description: 'Average weekly activity levels under 35%',
      frequency: 'Weekly',
      trigger: 'Email',
    },
    low_core_work: {
      thumbnail_src: SMART_NOTIFICATIONS_LOW_CORE_WORK,
      label: 'Members with low core work',
      description: 'Average weekly core work under 25%',
      frequency: 'Weekly',
      trigger: 'Email',
    },
    unproductive_work: {
      thumbnail_src: SMART_NOTIFICATIONS_UNPRODUCTIVE_WORK,
      label: 'Members with unproductive work time',
      description: 'Average daily unproductive work time exceeds 10% of all work time',
      frequency: 'Daily',
      trigger: 'Email',
    },
    members_using_social_media_websites: {
      thumbnail_src: SMART_NOTIFICATIONS_SOCIAL_MEDIA_WEBSITES,
      label: 'Members using social media websites',
      description: 'Members spend over 30 minutes per day on social media websites',
      frequency: 'Daily',
      trigger: 'Email',
    },
    members_not_using_required_apps: {
      thumbnail_src: SMART_NOTIFICATIONS_NOT_USING_APPS,
      label: 'Members not using required applications',
      description: 'Members spend under 30 mins per week on applications they are required to use',
      frequency: 'Weekly',
      trigger: 'Email',
    },
    members_using_AI_websites: {
      thumbnail_src: SMART_NOTIFICATIONS_AI_WEBSITES,
      label: 'Members using AI websites',
      description: 'Members spend over 30 minutes per day on GPT chatbot websites',
      frequency: 'Daily',
      trigger: 'Email',
    },
    members_usings_entertainment_websites: {
      thumbnail_src: SMART_NOTIFICATIONS_ENTERTAINMENT_WEBSITES,
      label: 'Members using entertainment websites',
      description: 'Members spend over 30 minutes per day on entertainment websites',
      frequency: 'Daily',
      trigger: 'Email',
    },
    idle_time: {
      thumbnail_src: SMART_NOTIFICATIONS_IDLE_TIME,
      label: 'Members with high idle time',
      description: 'Average weekly idle time above 15%',
      frequency: 'Weekly',
      trigger: 'Email',
    },
    manual_time: {
      thumbnail_src: SMART_NOTIFICATIONS_MANUAL_TIME,
      label: 'Members with high manual time',
      description: 'Average weekly manual time above 15%',
      frequency: 'Weekly',
      trigger: 'Email',
    },
  },
  triggers: {
    ICON_WATCH,
    ICON_BELL,
  },
  recommended: ['high_activity', 'overworking', 'underworking'],
  copy: {
    dialog: {
      create: {
        title: 'Add a smart notification',
      },
      edit: {
        title: 'Edit smart notification',
      },
      deliverBy: {
        tooltipCopy: {
          slack: {
            enabled: 'Receive this notification on Slack',
            disabled:
              'To enable receiving Smart Notifications through Slack, add our Slack integration (requires owner or manager role)',
          },
        },
      },
      metric: {
        tooltipCopy: 'Additional metrics including Core and Unproductive Work available within other frequencies',
      },
      monitoringActivity: `"Monitor desktop activity" setting must be enabled`,
      recordActivity: `"Record activity" setting must be enabled`,
    },
    template_dialog: {
      title: 'Add a smart notification',
      description:
        'Select a template from the options below to get started. Then, optionally customize the settings and assign members to monitor as well as those to receive notifications.',
    },
  },
  tooltips: {
    template: `<div class="tooltip fade top" role="tooltip">
          <div class="tooltip-arrow"></div>
          <div class="tooltip-inner" style="max-width:300px"></div>
        </div>`,
  },
  insights: {
    metricType: {
      monthly: {
        ...INSIGHTS_SMART_NOTIFICATIONS_HELPER.insightsBaseMetricTypes,
      },
      weekly: {
        ...INSIGHTS_SMART_NOTIFICATIONS_HELPER.insightsBaseMetricTypes,
      },
      daily: {
        ...INSIGHTS_SMART_NOTIFICATIONS_HELPER.insightsBaseMetricTypes,
        activity: 'Activity rate',
      },
      hourly: {
        ...INSIGHTS_SMART_NOTIFICATIONS_HELPER.insightsBaseMetricTypes,
        activity: 'Activity rate',
      },
    },
  },
};

export const SETTINGS_INSIGHTS = {
  sortOptions: [
    { key: 'common', label: 'Most common' },
    { key: 'recent', label: 'Most recent' },
  ],
  productivityOptions: [
    { label: 'Core work', id: 'core' },
    { label: 'Non-core work', id: 'non_core' },
    { label: 'Unproductive', id: 'unproductive' },
  ],
  toolTypeOptions: [
    { label: 'Apps', id: 'application' },
    { label: 'URLs', id: 'url' },
  ],
};

export const INSIGHTS_URL = '/organizations/:organizationId/insights';
export const INSIGHTS_SETTINGS_URL = '/organizations/:organizationId/settings/insights';

export const MEMBER_URL = '/organizations/:organizationId/members/:memberId';
export const TEAM_URL = '/teams/:teamId/members';

const baseInsightsCTADialogCopy = {
  title: 'Get the full value of Hubstaff Insights',
  description: `Make data-driven decisions with access to more data about your team's productivity and engagement. Uncover trends,
          benchmarks, and opportunities about your workforce. By enabling App & URL tracking, when your team uses the
          desktop app, you'll get a clear picture of what goes on during the workday.`,
  p1: {
    title: 'Time spent by category',
    description:
      'Get a better picture of the categorized apps & URLs your team uses and how they spend their work time.',
  },
  p2: {
    title: 'Core, non-core or unproductive time',
    description:
      'See how much time your team members spend on core, non-core or unproductive work (specific to each job type).',
  },
  p3: {
    title: 'Team highlights',
    description:
      'Let your virtual coach tell you where you need to look by surfacing changes in behavior for your team.',
  },
  p4: {
    title: 'Focus time',
    description: `See how much time your team spends working without distractions. That means no switching tasks, no calls, and no
      unproductive sites.`,
  },
};

export const EXPECTED_WORK_DAYS = {
  tooltips: {
    weekly: 'Changes to weekly limit take effect next week',
    daily: 'Changes to daily limit take effect next day',
    settingIsDisabled: "Settings disabled. If you want to edit it, disable 'Use shifts to set work allowance limits'.",
  },
};

export const INSIGHTS = {
  perPage: 50,
  filters: {
    date: [
      { id: 'this-day', text: 'Today', type: 'current', period: 'day' },
      { id: 'last-day', text: 'Yesterday', type: 'previous', period: 'day' },
      { id: 'this-week', text: 'This week', type: 'current', period: 'week' },
      { id: 'last-week', text: 'Last week', type: 'previous', period: 'week' },
      { id: 'this-month', text: 'This month', type: 'current', period: 'month' },
      { id: 'last-month', text: 'Last month', type: 'previous', period: 'month' },
    ],
  },
  api: {
    gitHubIntegration: {
      hosting: 'git_hostings',
      table: 'git_hostings_table',
    },
    highlights: {
      workTimeClassification: 'productivity_highlights',
      activity: 'activity_highlights',
      categories: 'categories_ranking',
      tools: 'tools_ranking',
    },
    performanceHighlights: 'highlights',
    smartNotifications: 'smart_notifications',
    ranking: {
      categories: 'categories_ranking',
      tools: 'tools_ranking',
      projects: 'projects_ranking',
      tasks: 'tasks_ranking',
    },
    benchmarks: {
      time: 'time_worked_summary',
      proficiency: 'productivity_summary',
      activity: 'activity_summary',
      tasks: 'tasks_summary',
      achievements: 'achievements_summary',
    },
    timeline: 'productivity_timeline',
    insightsTimeline: {
      team: 'timeline',
      user: 'user_timeline',
    },
    networkCollectionSetting: 'network_collection_setting',
    membersLocation: 'members_location',
    leaderboard: 'leaderboard',
    utilization: 'utilization_new',
    workTimeExpenditure: 'work_time_expenditure',
    startStopTime: 'start_stop_time',
    focusTime: 'focus_time',
    meetings: 'meetings',
    collaborations: 'collaborations',
    idleTime: 'idle_time',
    unusualActivity: {
      team: 'unusual_activities_list',
      individual: 'unusual_activities_by_user',
      user: 'unusual_user_activities',
    },
  },
  integrations: {
    github: {
      requestIntegrationList: [
        {
          id: 'adobe_illustrator',
          text: 'Adobe Illustrator',
        },
        {
          id: 'adobe_photoshop',
          text: 'Adobe Photoshop',
        },
        {
          id: 'asana',
          text: 'Asana',
        },
        {
          id: 'bitbucket',
          text: 'Bitbucket',
        },
        {
          id: 'clickup',
          text: 'ClickUp',
        },
        {
          id: 'firebase',
          text: 'Firebase',
        },
        {
          id: 'freshdesk',
          text: 'Freshdesk',
        },
        {
          id: 'gitlab',
          text: 'GitLab',
        },
        {
          id: 'hubspot',
          text: 'Hubspot',
        },
        {
          id: 'intercom',
          text: 'Intercom',
        },
        {
          id: 'jira',
          text: 'Jira',
        },
        {
          id: 'miro',
          text: 'Miro',
        },
        {
          id: 'monday',
          text: 'Monday',
        },
        {
          id: 'quickbooks',
          text: 'Quickbooks',
        },
        {
          id: 'rippling',
          text: 'Rippling',
        },
        {
          id: 'salesforce',
          text: 'Salesforce',
        },
        {
          id: 'slack',
          text: 'Slack',
        },
        {
          id: 'trello',
          text: 'Trello',
        },
        {
          id: 'typeform',
          text: 'Typeform',
        },
        {
          id: 'visual_studio',
          text: 'Visual Studio',
        },
        {
          id: 'xero',
          text: 'Xero',
        },
        {
          id: 'zendesk',
          text: 'Zendesk',
        },
        {
          id: 'zoho',
          text: 'Zoho',
        },
        {
          id: 'other',
          text: 'Other',
        },
      ],
      tooltip: {
        title:
          'Trend data is calculated using the selected time frame until the present date against the same period of the previous time frame.',
      },
      breakpoints: {
        sm: 480,
        md: 760,
      },
    },
  },
  meetings: {
    labels: {
      shares: {
        external: 'External',
        internal: 'Internal',
        recurring: 'Recurring',
        non_recurring: 'Non-recurring',
        one_on_one: 'One-on-ones',
        group: '3+ participants',
      },
    },
    retryFetch: [
      { repeat: 10, every: 3 },
      { repeat: 10, every: 30 },
      { repeat: 5, every: 60 },
    ],
    integrations: {
      google_calendar: { label: 'Sign in with Google' },
      microsoft_graph: { label: 'Sign in with Microsoft' },
    },
    integrationUrls: 'calendar_integration_urls',
  },
  collaborations: {
    retryFetch: [
      { repeat: 10, every: 3 },
      { repeat: 10, every: 30 },
      { repeat: 5, every: 60 },
    ],
    integrations: {
      /* google_collab: { label: 'Sign in with Google' }, */
      microsoft_graph: { label: 'Sign in with Microsoft' },
    },
    labels: {
      email: {
        sent_count: 'Emails sent',
        received_count: 'Emails received',
        unread_count: 'Emails unread',
      },
      call: {
        total_count: 'Calls',
        duration: 'Calls duration',
      },
      message: {
        total_count: 'Messages sent',
      },
    },
    icons: {
      email: {
        sent_count: 'hi-exit',
        received_count: 'hi-exit received',
        unread_count: 'hi-hidden',
      },
      call: {
        total_count: 'hi-phone',
        duration: 'hi-time',
      },
      message: {
        total_count: 'hi-exit',
      },
    },
    integrationUrls: 'collaboration_integration_urls',
  },
  utilization: {
    sections: [0.175, 0.1575, 0.035, 0.049, 0.2835],
    dayPeriod: {
      today: 'Today',
      yesterday: 'Yesterday',
    },
  },
  workTimeClassification: {
    core: 'Core work',
    unproductive: 'Unproductive',
    'non-core': 'Non-core work',
    unknown: 'Unclassified',
  },
  workTimeClassificationRemoteVsOffice: {
    core: 'Core',
    unproductive: 'Unproductive',
    'non-core': 'Non-core',
    unknown: 'Unclassified',
  },
  unusualActivity: {
    labels: {
      'high-activity': {
        text: 'Unusually high activity',
        tooltip: 'Very high activity detected for an extended period on keyboard and/or mouse',
        url: 'https://support.hubstaff.com/hubstaff-insights-unusual-activity/#unusually-high-activity',
      },
      'suspicious-activity': {
        text: 'Suspicious app / URL',
        tooltip: 'Known fake activity App/URL detected',
        url: 'https://support.hubstaff.com/hubstaff-insights-unusual-activity/#suspicious-application',
      },
      'long-period-of-single-activity-without-typing': {
        text: 'Predominantly mouse usage',
        tooltip: 'Keyboard activity stayed under 1% while mouse was active for over 50 minutes',
        url: 'https://support.hubstaff.com/hubstaff-insights-unusual-activity/#low-single-mouse',
      },
      'long-period-of-single-activity-without-mouse': {
        text: 'Predominantly keyboard usage',
        tooltip: 'Mouse activity stayed under 1% while keyboard was active for over 50 minutes',
        url: 'https://support.hubstaff.com/hubstaff-insights-unusual-activity/#low-single-keyboard',
      },
      'consistent-activity': {
        text: 'Unusually consistent activity',
        tooltip: 'Activity rate remained unchanged for over 40 minutes',
        url: 'https://support.hubstaff.com/hubstaff-insights-unusual-activity/#unusually-consistent-activity',
      },
      'breakless-work': {
        text: 'Breakless work',
        tooltip:
          'Member tracked time for over 5 consecutive hours without stopping their Hubstaff timer AND their activity never dropped below 30%',
        url: 'https://support.hubstaff.com/hubstaff-insights-unusual-activity/#breakless-work',
      },
      'sustained-high-focus-time': {
        text: 'Sustained high focus time',
        tooltip: 'During a single day, the member had over 5 hours of focus time above 80%',
        url: 'https://support.hubstaff.com/hubstaff-insights-unusual-activity/#sustained-high-focus',
      },
      'automation-like-activity': {
        text: 'Automated activity',
        tooltip: 'AI analysis of mouse and keyboard behavior found patterns consistent with automated (bot) activity',
        url: 'https://support.hubstaff.com/hubstaff-insights-unusual-activity/#automated-activity',
      },
    },
  },
  benchmarks: {
    time: 'Time worked',
    proficiency: 'Core Work',
    activity: 'Activity',
    tasks: 'To-dos completed',
    achievements: 'Achievements',
  },
  /** Configuration parameters for widget limits and thresholds */
  parameters: {
    rankingLimit: 10,
    highlightsRankingLimit: 4,
    highlightsRankingViewMoreLimit: 18,
    workTimeExpenditureLimit: 5,
    unusualActivityLimit: 5,
    unusualActivityViewMoreLimit: 15,
    unusualActivityMemberViewMoreLimit: 9,
    unusualActivityTeamViewMoreLimit: 15,
  },
  performanceHighlights: {
    styles: {
      ascending: {
        arrow: { color: '#0e9f6e', transform: 'rotate(270deg)' },
        text: { color: '#0e9f6e' },
      },
      descending: {
        arrow: { color: '#0168dd', transform: 'rotate(90deg)' },
        text: { color: '#0168dd' },
      },
    },
    labels: {
      timeFrame: {
        today: {
          current: 'last week',
          previous: 'previous 3 weeks',
        },
        yesterday: {
          current: 'last week',
          previous: 'previous 3 weeks',
        },
        'this-week': {
          current: 'last week',
          previous: 'previous 3 weeks',
        },
        'last-week': {
          current: 'last week',
          previous: 'previous 3 weeks',
        },
        'this-month': {
          current: 'last month',
          previous: 'previous 3 months',
        },
        'last-month': {
          current: 'last month',
          previous: 'previous 3 months',
        },
      },
      trend: {
        ascending: 'higher',
        descending: 'lower',
      },
      metric: {
        work_time: 'Work time',
        activity: 'Activity',
        core_work: 'Core work',
      },
    },
  },
  banners: {
    copy: {
      upgrade: {
        title: 'Upgrade to enable App & URL tracking',
        description:
          'To access the full power of Insights, upgrade your plan and enable App & URL tracking for your members. Make sure they are using Hubstaff’s desktop app to track their time while working.',
        cta: 'Upgrade your plan',
        dialog: {
          ...baseInsightsCTADialogCopy,
        },
      },
      enable: {
        title: 'Enable App & URL tracking',
        description:
          'Unleash the full analytical power of Hubstaff Insights by enabling App & URL tracking for your members. Don’t forget, members must use the desktop app to track their time.',
        cta: 'Enable App & URL tracking',
        dialog: {
          ...baseInsightsCTADialogCopy,
        },
      },
      workforce: {
        title: 'Introducing Insights workforce analytics',
        description: `Reduce the stress of managing a remote team and gain visibility into what's going on in the workday. Uncover trends, benchmarks, and opportunities to coach your team to the next level.`,
        cta: 'Try it now',
        dialog: {
          ...baseInsightsCTADialogCopy,
          title: 'Introducing Insights workforce analytics',
          description: 'Take a look at what you can uncover with Hubstaff Insights:',
        },
      },
      suspicious_behavior: {
        title: 'Anti-cheat notifications',
        description:
          'Add Hubstaff Insights to your plan and be notified about members who might be using fake activity apps to cheat work.',
        cta: 'Add Insights to your plan',
      },
    },
    ctaType: {
      upgrade: 'success',
      enable: 'primary',
    },
  },
  /** Available tab names in the Insights interface */
  tabs: ['performance', 'highlights', 'timeline', 'unusual-activity', 'output'],
  /** Default tab to show when no tab is specified */
  defaultTab: 'performance',
  /** Widget registry defining which widgets to load for each tab */
  widgetRegistry: {
    highlights: {
      base: [{ widgetKey: 'performanceHighlights' }, { widgetKey: 'smartNotifications' }],
    },
    performance: {
      base: [
        { widgetKey: 'utilization' },
        { widgetKey: 'highlights.workTimeClassification' },
        { widgetKey: 'highlights.activity' },
        { widgetKey: 'focusTime' },
        { widgetKey: 'meetings' },
        { widgetKey: 'collaborations' },
        { widgetKey: 'workTimeExpenditure', extraQueryParams: { limit: 'parameters.workTimeExpenditureLimit' } },
        { widgetKey: 'ranking.categories', extraQueryParams: { limit: 'parameters.rankingLimit' } },
        { widgetKey: 'highlights.tools', extraQueryParams: { limit: 'parameters.highlightsRankingLimit' } },
      ],
      conditional: {
        teamDashboard: [
          { widgetKey: 'leaderboard' },
          { widgetKey: 'ranking.projects', extraQueryParams: { limit: 'parameters.rankingLimit' } },
          { widgetKey: 'ranking.tasks', extraQueryParams: { limit: 'parameters.rankingLimit' } },
        ],
        userDashboard: [
          { widgetKey: 'timeline' },
          { widgetKey: 'ranking.projects', extraQueryParams: { limit: 'parameters.rankingLimit' } },
          { widgetKey: 'ranking.tasks', extraQueryParams: { limit: 'parameters.rankingLimit' } },
        ],
        remoteVsOffice: [
          { widgetKey: 'membersLocation' },
          { widgetKey: 'startStopTime' },
          { widgetKey: 'idleTime' },
        ],
        remoteVsOfficeWidgetsInStandardMode: [
          { widgetKey: 'startStopTime' },
          { widgetKey: 'idleTime' },
        ],
      },
    },
    timeline: {
      base: [{ widgetKey: 'insightsTimeline.team' }, { widgetKey: 'insightsTimeline.user' }],
    },
    'unusual-activity': {
      base: [],
      conditional: {
        teamDashboard: [{ widgetKey: 'unusualActivity.team' }],
        userDashboard: [{ widgetKey: 'unusualActivity.individual' }],
      },
    },
    output: {
      base: [
        {
          widgetKey: 'gitHubIntegration.hosting',
          extraQueryParams: { integration_type: 'github' },
          skippableAbortParams: ['limit', 'integration_type'],
        },
        {
          widgetKey: 'gitHubIntegration.table',
          extraQueryParams: { integration_type: 'github' },
          skippableAbortParams: ['limit', 'integration_type'],
        },
      ],
    },
    activities: {
      base: [{ widgetKey: 'meetings' }, { widgetKey: 'highlights.workTimeClassification' }, { widgetKey: 'focusTime' }],
    },
  },
  tooltips: {
    focusTime: {
      content: `
        <div style="text-align: left;">
          <p>Focus time is defined as:</p>
          <ul style="padding-left: 2rem; margin-top: 1rem;">
            <li>30+ minutes of continuous time tracked to a single project or task;</li>
            <li>Less than 90 sec of unproductive apps/URLs;</li>
            <li>Less than 90 sec of time spent in the following categories: Communication, Meetings, Entertainment, News, Social media, and Shopping.</li>
          </ul>
          <p>Metrics are calculated per member, per day.</p>
        </div>
      `,
    },
    workTimeClassification: {
      content:
        'Average work time proficiency for the selected time period, calculated based on the classification of accessed apps & URLs. There are 3 classifications: Core work, Non-core work and Unproductive work. To edit them, go to Settings > Insights',
    },
    rankings: {
      suspiciousBehaviour: {
        detected:
          'Fake activity generator apps or URLs were detected in this period. Advanced details can be found within the Unusual activity widget.',
        undetected: 'No fake activity generator apps or URLs were detected in this period',
      },
    },
    collaborations: {
      content:
        '<div>See how your teams engage in collaboration by viewing messages and emails exchanged, and calls made using Microsoft Teams.</div><div>*Data displayed as averages</div>',
    },
    /* Unicode symbol \u00A0 is a non-breaking space for better formatting */
    utilization: {
      content:
        'Indicates the\u00A0worked hours status of\u00A0members or\u00A0teams based on\u00A0their work time target. The\u00A0default target is\u00A08h/day and you can configure it in\u00A0the\u00A0member profile page',
      remoteVsOfficeContent: 'Compare daily working averages between remote and\u00A0office work modes',
      target: {
        default: 'target is\u00A0calculated based on\u00A0the\u00A0total expected work hours for\u00A0the\u00A0week',
        today:
          'target is\u00A0determined by\u00A0a\u00A0combination of\u00A0the\u00A0member’s cumulative weekly work hours and\u00A0the\u00A0daily work hour target for\u00A0the\u00A0week',
      },
    },
    engagementScore: {
      content: `
        <div style="text-align: left;">
          <p>Indicates a member’s or team’s work engagement. It compares 4 metrics (Activity, Daily focus, Core work, and Utilization) to the median of each member's job type to show where they fall in comparison to others.</p>
          <ul style="padding-left: 2rem; margin-top: 0.5rem;">
            <li>Red: Very low</li>
            <li>Yellow: Slightly low</li>
            <li>Blue: Healthy</li>
            <li>Green: High</li>
            <li>Red: Too high</li>
          </ul>
        </div>
      `,
      emptyReasons: {
        tools_tracking_disabled: {
          content: `
            <div style="text-align: left;">
              <p>Engagement scores do not calculate when Track Apps & URLs is off</p>
              <a href="https://support.hubstaff.com/hubstaff-insights-add-on/#engagement" target="_blank" rel="noopener noreferrer">See more</a>
            </div>
          `,
        },
        occupation_missing: {
          content: `
            <div style="text-align: left;">
              <p>Engagement scores do not calculate when job type is missing</p>
              <a href="https://support.hubstaff.com/hubstaff-insights-add-on/#engagement" target="_blank" rel="noopener noreferrer">See more</a>
            </div>
          `,
        },
        desktop_app_unused: {
          content: `
            <div style="text-align: left;">
              <p>Engagement scores can only calculate when Hubstaff desktop app is used</p>
              <a href="https://support.hubstaff.com/hubstaff-insights-add-on/#engagement" target="_blank" rel="noopener noreferrer">See more</a>
            </div>
          `,
        },
        benchmark_missing: {
          content: `
            <div style="text-align: left;">
              <p>Job type does not yet have benchmark data</p>
            </div>
          `,
        },
        no_data: {
          content: `
            <div style="text-align: left;">
              <p>No time tracked or not yet calculated for current date range</p>
            </div>
          `,
        },
      },
    },
    unusualActivity: {
      content: 'Hubstaff doesn’t recommend making employment decisions based solely on unusual activity data.',
    },
    confidenceLevel: {
      content: 'The highest activity level reached in the selected date range.',
    },
    aiDetectedDuration: {
      content: 'Activity is analysed in 4-hour blocks.',
    },
  },
  benchmarks_averages: {
    labels: {
      industry: 'Industry',
      organization: 'Organization',
      occupation: 'Job type',
    },
    // We use the same copy for different warnings for now
    // TODO: define different copy when it's ready to launch
    warnings: {
      widget: {
        few_data: 'This range may look atypical due to a small sample size',
        range_below_min: 'Small sample size',
        range_above_max: 'Small sample size',
      },
      legend: 'Range size may look too big or small due to a small sample size of the benchmarks.',
    },
    widgets: ['utilization', 'activity_highlights', 'productivity_highlights'],
  },
  timeline: {
    status: {
      call: { text: 'On call', class: 'badge-green', icon: 'hi-phone' },
      focused: { text: 'Focused', class: 'badge-purple', icon: 'hi-asterisk' },
      meeting: { text: 'In a meeting', class: 'badge-blue', icon: 'hi-calendar' },
    },
    metrics: {
      tracked: { toggle: false, title: 'Tracked' },
      manual: { toggle: true, title: 'Manual' },
      idle: { toggle: true, title: 'Idle' },
      active: {
        toggle: true,
        title: 'Activity level',
        info: 'Activity level is shown with an area graph, in 30 min averages',
      },
      meetings: {
        toggle: true,
        title: 'Meetings',
        info: 'Only meetings that are booked in the member’s calendar are shown',
      },
      shifts: { toggle: true, title: 'Shifts' },
      breaks: { toggle: true, title: 'Break' },
      holidays: { toggle: true, title: 'Holiday' },
      pto: { toggle: true, title: 'PTO' },
    },
  },
  acitivity_ranges: {
    high: { key: 'high', label: 'High (51% - 100%)', tooltip: 'high-activity range' },
    medium: { key: 'medium', label: 'Mid (21% - 50%)', tooltip: 'mid-activity range' },
    low: { key: 'low', label: 'Low (1% - 20%)', tooltip: 'low-activity range' },
  },
  engagement_ranges: [
    { key: 'too-low', value: 0 },
    { key: 'low', value: 70 },
    { key: 'normal-low', value: 90 },
    { key: 'normal-high', value: 101 },
    { key: 'high', value: 111 },
    { key: 'too-high', value: 125 },
  ],
  productivityOptions: [
    { label: 'Core work', id: 'core' },
    { label: 'Non-core work', id: 'non_core' },
    { label: 'Unproductive', id: 'unproductive' },
  ],
  remoteVsOffice: {
    locationTypeNames: {
      remote: 'Remote',
      on_site: 'Office',
      unknown: '--',
    },
  },
  empty_states: {
    empty_description: {
      title: 'No data',
      description: '',
    },
    no_data: {
      title: 'No data',
      description: 'There was no data registered in the time period selected',
      no_data_symbol: '--',
    },
    missing_network_collection: {
      title: 'Network data collection disabled',
      description: 'Network data collection is currently disabled for selected members',
    },
    activity_tracking_disabled: {
      title: 'Record activity disabled',
      description: 'Enable "Record activity" setting to be able to see activity metrics',
    },
    tools_tracking_disabled: {
      title: 'Monitor desktop activity disabled',
      description: 'Enable the feature "Monitor desktop activity" to be able to see activity metrics',
    },
    tools_tracking_unused: {
      title: 'Apps & URLs tracking disabled',
      description: 'Enable App & URL tracking setting to be able to see more metrics',
    },
  },
};

export const SCREENSHOTS = {
  labels: {
    manual_time: 'Manual',
    mobile_time: 'Mobile',
    browser_time: 'Browser',
    web_time: 'Web timer',
    api_time: 'API',
    resumed_time: 'Resumed',
    idle_time: 'Idle',
  },
};

export const PROMOTION_FEATURE_BANNERS = {
  scheduled_reports: {
    title: 'Schedule reports to be delivered automatically',
    description:
      'Customize reports by adjusting filters and columns to display data that matters most to you. Make data-driven decisions by scheduling reports to be delivered directly by email.',
    features: [
      'Track activity trends',
      'Reports for payroll',
      'Client billing',
      'Project summary',
      'Productivity report',
    ],
    cta: 'Schedule report',
    learn_more_link: 'https://support.hubstaff.com/scheduled-reports',
    illustration: SCHEDULED_REPORT_BANNER_ILLUSTRATION,
  },
  teams: {
    title: 'Benefits of teams',
    description:
      'Having teams makes it quick and easy to add new people to several projects automatically. It also allows you to assign a team lead with extra permissions for the people on their team. Delegate tasks like creating shifts, setting up projects, approving timesheets, and more.',
    features: ['Assign members to projects automatically', 'Manage team lead permissions', 'Measure team productivity'],
    cta: 'Create team',
    learn_more_link: 'https://support.hubstaff.com/teams-overview/#create',
    illustration: TEAMS_PROMOTION_BANNER_ILLUSTRATION,
  },
};

export const PROMOTION_FEATURE_BANNER_DIALOGS = {
  scheduled_reports: {
    title: 'Send reports automatically',
    description:
      'You can schedule any report to be sent automatically to you, your team members, or your clients. Save time and automate your reporting right to your inbox.',
    features: ['Customize report settings', "Click 'Schedule' to set delivery options", 'Reports arrive in your inbox'],
    cta: 'View schedule options',
    illustration: SCHEDULED_REPORT_BANNER_ILLUSTRATION,
  },
  teams: {
    title: 'Get more done with teams!',
    description:
      'Creating teams allows you to automatically assigning members to multiple projects. You can also customize team lead permissions to delegate tasks like approving timesheets, managing time off, and more.',
    features: [
      'Assign members to projects automatically',
      'Assign team lead permissions and delegate work',
      'Measure teams productivity in your organization',
    ],
    cta: 'Create team',
    illustration: TEAMS_PROMOTION_BANNER_ILLUSTRATION,
  },
};

export const JOB_SITE_FILE_IMPORT_TEMPLATE_URL = getFileImportTemplateUrl('job_sites.csv');
export const PROJECT_FILE_IMPORT_TEMPLATE_URL = getFileImportTemplateUrl('projects.csv');
export const CLIENT_FILE_IMPORT_TEMPLATE_URL = getFileImportTemplateUrl('clients.csv');
export const INVITE_MEMBER_FILE_IMPORT_TEMPLATE_URL = getFileImportTemplateUrl('members.csv');
export const CREATE_ACCOUNT_FILE_IMPORT_TEMPLATE_URL = getFileImportTemplateUrl('create_accounts.csv');
export const MEMBERS_EMAIL_FILE_IMPORT_TEMPLATE_URL = getFileImportTemplateUrl('members_email.csv');

export function CHART_DATA_COLORS() {
  return {
    Tracked: '#2aa7ff',
    Manual: '#a7d9fc',
    Break: '#e5e7eb',
    Overtime: '#b977ff',
    Holidays: '#0e9f6e',
    'Time off': '#bcf0da',
    'Time off/Holiday': '#bcf0da',
    // Idle: '#f98080', not used yet
  };
}

export function CHART_DATA_GROUPS() {
  return [Object.keys(CHART_DATA_COLORS())];
}

export const REPORT_CHART_POPOVER_CONTENT_TITLES = {
  timeOffHoliday: 'Time off/Holiday',
  time_off: 'Time off',
};

export const EMPLOYMENT_TYPE_OPTIONS = [
  { id: 'contractor_hourly', text: 'Contractor - hourly' },
  { id: 'contractor_fixed_rate', text: 'Contractor - fixed rate' },
  { id: 'contractor_project_based', text: 'Contractor - project based' },
  { id: 'fte_hourly', text: 'FTE - hourly (full-time employee)' },
  { id: 'fte_salary', text: 'FTE - salary (full-time employee)' },
  { id: 'pte_hourly', text: 'PTE - hourly (part-time employee)' },
  { id: 'pte_salary', text: 'PTE - salary (part-time employee)' },
];
export const WORKPLACE_MODEL_OPTIONS = [
  { id: 'in_office', text: 'In-office' },
  { id: 'remote', text: 'Remote' },
  { id: 'hybrid', text: 'Hybrid' },
];
export const EMPLOYED_THROUGH_OPTIONS = [
  { id: 'direct', text: 'Direct - hired by us' },
  { id: 'vendor', text: 'Vendor' },
  { id: 'eor', text: 'EOR' },
  { id: 'subsidiary', text: 'Subsidiary' },
];
export const TERMINATION_REASON_OPTIONS = [
  { id: 'voluntary', text: 'Voluntary' },
  { id: 'involuntary', text: 'Involuntary' },
  { id: 'contract_ended', text: 'Contract ended' },
];
export const MEMBERS_SELECTION_SORT_OPTIONS = [
  { key: 'az', field: 'name', label: 'A-Z', value: 'asc' },
  { key: 'za', field: 'name', label: 'Z-A', value: 'desc' },
  { key: 'selected', field: 'selected', label: 'Selected', value: true },
  { key: 'unselected', field: 'selected', label: 'Unselected', value: false },
];

export const CUSTOM_ERROR_MESSAGES = {
  projects: { name: [{ 'already exists': 'A project with this name already exists' }] },
};

export const DIALOG_OPEN_WIN_EVENT = 'appdialog:open';
export const DIALOG_CLOSE_WIN_EVENT = 'appdialog:close';
export const SIDEBAR_OPEN_WIN_EVENT = 'appsidebar:open';
export const LAZY_OPEN_WIN_EVENT = 'applazyselect:open';

export const ACTIVITIES_AVATAR_SIDE_MARKERS = {
  viewRoute: {
    active: ACTIVITIES_VIEW_ROUTE_ACTIVE,
    inactive: ACTIVITIES_VIEW_ROUTE_INACTIVE,
  },
  viewInfo: {
    active: ACTIVITIES_VIEW_INFO_ACTIVE,
    inactive: ACTIVITIES_VIEW_INFO_INACTIVE,
  },
};

export const BANNER_AD_LOGOS = {
  default: HUBSTAFF_LOGO,
  transferwise: TRANSFERWISE_LOGO,
};

export const INFORMATIONAL_BANNER_ILLUSTRATIONS = {
  default: HUBSTAFF_LOGO,
  teams: TEAMS_PROMOTION_BANNER_ILLUSTRATION,
  scheduled_reports: SCHEDULED_REPORT_BANNER_ILLUSTRATION,
  contractor_compliance: CONTRACTOR_COMPLIANCE_BANNER_ILLUSTRATION,
};

export const DIALOG_BANNER_ILLUSTRATIONS = {
  ...INFORMATIONAL_BANNER_ILLUSTRATIONS,
};

export const ACHIEVEMENT_BADGES = {
  efficiency_pro: {
    src: ACHIEVEMENT_BADGE_EFFICIENCY_PRO,
    alt: 'Efficiency pro',
  },
  time_hero: {
    src: ACHIEVEMENT_BADGE_TIME_HERO,
    alt: 'Time hero',
  },
  productivity_champ: {
    src: ACHIEVEMENT_BADGE_PRODUCTIVITY_CHAMP,
    alt: 'Productivity champ',
  },
};

export const ACTIVITIES_INSIGHTS_PLACEHOLDERS = {
  donut_chart: ACTIVITIES_INSIGHTS_DONUT_CHART_PLACEHOLDER,
  pie_chart: ACTIVITIES_INSIGHTS_PIE_CHART_PLACEHOLDER,
};

export const GETTING_STARTED = {
  no_team_member_selected: {
    src: GETTING_STARTED_NO_TEAM_MEMBER_SELECTED,
    alt: 'No team member selected',
  },
  timesheet_approved: {
    src: GETTING_STARTED_TIMESHEET_APPROVED,
    alt: 'Timesheet approved',
  },
  free_trial_insights: {
    src: GETTING_STARTED_FREE_TRIAL_INSIGHTS,
    alt: 'Free trial insights',
  },
  screenshots: GETTING_STARTED_SCREENSHOTS,
  integration_completed: IMAGE_SET_UP_THE_SUCCESS,
  wise_banner: INTEGRATIONS_HERO_WISE,
  wise_logo: TRANSFERWISE_LOGO,
  app_images: [
    GETTING_STARTED_DOWNLOAD_APP_IMG_1,
    GETTING_STARTED_DOWNLOAD_APP_IMG_2,
    GETTING_STARTED_DOWNLOAD_APP_IMG_3,
  ],
};

export const INSIGHTS_ASSETS = {
  logo: {
    src: INSIGHTS_LOGO,
    alt: 'Insights',
  },
  empty_states: {
    activity_tracking_disabled: {
      src: INSIGHTS_ACTIVITY_TRACKING_DISABLED,
      alt: 'Record activity disabled',
    },
    tools_tracking_disabled: {
      src: INSIGHTS_TOOLS_TRACKING_DISABLED,
      alt: 'Monitor desktop activity disabled',
    },
    tools_tracking_unused: {
      src: INSIGHTS_TOOLS_TRACKING_UNUSED,
      alt: 'Apps & URLs tracking disabled',
    },
    missing_network_collection: {
      src: INSIGHTS_TOOLS_TRACKING_UNUSED,
      alt: 'Network data collection disabled',
    },
  },
  no_data_tracked: {
    src: IMAGE_EMPTY_BOX,
    alt: 'No data found',
  },
  no_time_tracked: {
    src: INSIGHTS_NO_TIME_TRACKED,
    alt: 'No tracked activity found',
  },
  integration_unauthorized: {
    src: INSIGHTS_INTEGRATION_UNAUTHORIZED,
    alt: 'You are not authorized to integrate this calendar',
  },
  github_integration_logo: {
    src: INSIGHTS_GITHUB_INTEGRATION_LOGO,
    alt: 'GitHub',
  },
  github_integration_logo_white: {
    src: INSIGHTS_GITHUB_INTEGRATION_LOGO_WHITE,
    alt: 'GitHub',
  },
  integration_logos: {
    google_calendar: {
      src: INSIGHTS_MEETINGS_GOOGLE_LOGO,
      alt: 'Sign-in with Google',
    },
    microsoft_graph: {
      src: INSIGHTS_MEETINGS_MICROSOFT365_LOGO,
      alt: 'Sign-in with Microsoft 365',
    },
  },
  donut_chart_placeholder: {
    src: INSIGHTS_DONUT_CHART_PLACEHOLDER,
  },
  short_paragraph_placeholder: {
    src: INSIGHTS_SHORT_PARAGRAPH_PLACEHOLDER,
  },
  meetings_dialog_illustration: {
    src: INSIGHTS_MEETINGS_DIALOG_ILLUSTRATION,
  },
  meetings_connect: {
    src: INSIGHTS_MEETINGS_CONNECT,
    alt: 'Connect an account to start using the Meetings widget',
  },
  column_chart_placeholder: {
    src: INSIGHTS_COLUMN_CHART_PLACEHOLDER,
  },
  banners: {
    illustration: {
      upgrade: {
        src: INSIGHTS_BANNER_UPGRADE,
        alt: 'Upgrade to enable App & URL tracking',
      },
      enable: {
        src: INSIGHTS_BANNER_ENABLE,
        alt: 'Enable App & URL tracking',
      },
      workforce: {
        src: INSIGHTS_BANNER_WORKFORCE,
        alt: 'Introducing Insights workforce analytics',
      },
      suspicious_behavior: {
        src: INSIGHTS_BANNER_SUSPICIOUS_BEHAVIOR,
        alt: 'Anti-cheat notifications',
      },
      dialog: {
        wte: {
          src: INSIGHTS_BANNER_DIALOG_WTE,
          alt: 'Time spent by category',
        },
        app_urls: {
          src: INSIGHTS_BANNER_DIALOG__APP_URLS,
          alt: 'Core, non-core or unproductive time',
        },
        highlights: {
          src: INSIGHTS_BANNER_DIALOG_HIGHLIGHTS,
          alt: 'Team highlights',
        },
        focus_time: {
          src: INSIGHTS_BANNER_DIALOG_FOCUS_TIME,
          alt: 'Focus time',
        },
      },
    },
  },
  ranking_placeholder: {
    4: { src: INSIGHTS_RANKING_BLURRED_ITEMS_4 },
    5: { src: INSIGHTS_RANKING_BLURRED_ITEMS_5 },
    10: { src: INSIGHTS_RANKING_BLURRED_ITEMS_10 },
  },
  timeline_placeholder: {
    src: INSIGHTS_TIMELINE_BLURRED_APPS_URLS,
  },
  insights_output_no_data: {
    src: INSIGHTS_OUTPUT_NO_DATA,
    alt: 'Measure key metrics of your team members based on the main apps they use to work and get and stay synced and stay tuned to their work output performance',
  },
  unusual_activities_blurred_apps: {
    src: INSIGHTS_UNUSUAL_ACTIVITIES_BLURRED_APPS,
    alt: 'Blurred Apps',
  },
  cancellation_flow: {
    illustration_red: {
      src: INSIGHTS_CANCELLATION_BANNER_ILLUSTRATION_RED,
    },
    illustration_blue: {
      src: INSIGHTS_CANCELLATION_BANNER_ILLUSTRATION_BLUE,
    },
    illustration_30_days: {
      src: INSIGHTS_CANCELLATION_BANNER_ILLUSTRATION_30_DAYS,
    },
    illustration_10_percent: {
      src: INSIGHTS_CANCELLATION_BANNER_ILLUSTRATION_10_PERCENT,
    },
  },
};

export const SETTINGS = {
  smart_notifications: {
    presets: {
      high_activity: {
        src: SETTINGS_SMART_NOTIFICATION_HIGH_ACTIVITY,
        thumbnail_src: SMART_NOTIFICATIONS_SUSPICIOUSLY_HIGH_ACTIVITY,
        label: 'Suspiciously high activity',
        description: 'Average hourly activity levels exceed 90%',
        frequency: 'Hourly',
        trigger: 'Email',
      },
      overworking: {
        src: SETTINGS_SMART_NOTIFICATIONS_OVERWORKING,
        thumbnail_src: SMART_NOTIFICATIONS_OVERWORKING,
        label: 'Members overworking',
        description: 'Average daily work time exceeds 9.5 hours per week',
        frequency: 'Weekly',
        trigger: 'Email',
      },
      underworking: {
        src: SETTINGS_SMART_NOTIFICATIONS_UNDERWORKING,
        thumbnail_src: SMART_NOTIFICATIONS_UNDERWORKING,
        label: 'Members underworking',
        description: 'Average daily work time falls below 5 hours',
        frequency: 'Weekly',
        trigger: 'Email',
      },
      low_activity: {
        src: SETTINGS_SMART_NOTIFICATIONS_LOW_ACTIVITY,
        thumbnail_src: SMART_NOTIFICATIONS_LOW_ACTIVITY,
        label: 'Members with low activity level',
        description: 'Average weekly activity levels under 35%',
        frequency: 'Weekly',
        trigger: 'Email',
      },
      low_core_work: {
        thumbnail_src: SMART_NOTIFICATIONS_LOW_CORE_WORK,
        label: 'Members with low core work',
        description: 'Average weekly core work under 25%',
        frequency: 'Weekly',
        trigger: 'Email',
      },
      unproductive_work: {
        thumbnail_src: SMART_NOTIFICATIONS_UNPRODUCTIVE_WORK,
        label: 'Members with unproductive work time',
        description: 'Average daily unproductive work time exceeds 10% of all work time',
        frequency: 'Daily',
        trigger: 'Email',
      },
      suspicious_application_autoclicker: {
        src: SETTINGS_SMART_NOTIFICATION_HIGH_ACTIVITY,
        thumbnail_src: SMART_NOTIFICATIONS_SUSPICIOUSLY_HIGH_ACTIVITY,
        label: 'Alert on AutoClicker',
        description: '',
        frequency: 'Daily',
        trigger: 'Email',
      },
    },
    triggers: {
      ICON_WATCH,
      ICON_BELL,
    },
  },
};

export const ORGANIZATION = {
  archive_flow: {
    banner_illustration_red: {
      src: ORGANIZATION_ARCHIVE_BANNER_ILLUSTRATION_RED,
    },
  },
};

export const TASKS_LOGO = {
  src: IMAGE_HS_TASKS_LOGO,
  alt: 'Tasks',
};
